import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from '@components/Provider';
import Loading from '@components/Loading';
import ResetPasswordPresenter from './ResetPasswordPresenter';
import { CapaErrorCode, useChangePasswordMutation } from '@generated/graphql';
import useClient from '@hooks/useClient';
import { IRequestPasswordForm } from './types';
import {
  authStorageClear,
  STORAGE_ACTION,
  getStorageItem
} from '@utils/storage';
import CommonLayout from '@routes/Common/CommonLayout';
import errorMessage from '@utils/errorMessage';

const ResetPasswordContainer: React.FC = () => {
  const isGhost = getStorageItem(STORAGE_ACTION.IS_GHOST_CLIENT);
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { onInitClient } = useClient();
  const [updatePassword, { loading }] = useChangePasswordMutation({});

  const onUpdate = (req: IRequestPasswordForm) => {
    if (isGhost && isGhost === 'true') return;
    updatePassword({
      variables: {
        input: {
          password: req.password,
          newPassword: req.newPassword!,
          newPasswordConfirm: req.newPassword!
        }
      }
    })
      .then((data) => {
        const result = data.data?.changePassword.result;
        const {
          Success,
          PasswordIncorrect,
          ParmeterValidationError
        } = CapaErrorCode;

        switch (result) {
          case Success: {
            onInitClient();
            authStorageClear();
            enqueueSnackbar(`비밀번호가 변경되었습니다.`, {
              variant: 'success'
            });
            localStorage.removeItem(STORAGE_ACTION.KEEP_LOGGED_IN);
            history.push('/login');
            break;
          }
          case PasswordIncorrect: {
            enqueueSnackbar(`비밀번호가 일치하지 않습니다.`, {
              variant: 'error'
            });
            break;
          }
          case ParmeterValidationError: {
            enqueueSnackbar(`영문+숫자 혼용 8글자 이상으로 입력해주세요.`, {
              variant: 'error'
            });
            break;
          }
          default: {
            enqueueSnackbar(errorMessage.login, { variant: 'error' });
          }
        }
      })
      .catch((err) => {
        enqueueSnackbar(errorMessage.login, { variant: 'error' });
      });
  };

  return (
    <CommonLayout gnbTabs={<></>} fullHeight>
      <Loading open={loading} />
      <ResetPasswordPresenter onUpdate={onUpdate} />
    </CommonLayout>
  );
};

export default ResetPasswordContainer;
